import { useEffect, useRef } from "react";
import { useAppStore } from "@/store/use-app-store";
import { _loadOverrides } from "./i18n";

/**
 * TranslationProvider
 *
 * Watches the active language and loads DB-humanized translation overrides
 * whenever it changes. The overrides are stored in the module-level _dbOverrides
 * map in i18n.ts so that t5() calls automatically use the improved text.
 *
 * This component renders nothing — it's a pure side-effect provider.
 * Mount it once near the root of the app (inside QueryClientProvider).
 */
export function TranslationProvider({ children }: { children: React.ReactNode }) {
  const { language } = useAppStore();
  const prevLang = useRef<string>("");

  useEffect(() => {
    if (language && language !== prevLang.current) {
      prevLang.current = language;
      _loadOverrides(language);
    }
  }, [language]);

  return <>{children}</>;
}
